module.exports = __webpack_public_path__ + "img/type3_check.2b44213a.png";